export const Types = {
    GET_CREATORS: "GET_CREATORS",
    SET_CREATORS: "SET_CREATORS",
    GET_STATUS: "GET_STATUS",
    SET_STATUS: "SET_STATUS",
    GET_CANCEL_ORDER: "GET_CANCEL_ORDER",
    SET_CANCEL_ORDER: "SET_CANCEL_ORDER",
    GET_CONFIRM_ORDER: "GET_CONFIRM_ORDER",
    SET_CONFIRM_ORDER: "SET_CONFIRM_ORDER",
    RESET_CANCEL_ORDER: "RESET_CANCEL_ORDER",
    EMPTY_STATUS: "EMPTY_STATUS",
    GET_EXCEL_FILE: "GET_EXCEL_fILE_OPERATOR_REQUESTS"
};

export const getCreatorList = (payload) => ({
    type: Types.GET_CREATORS,
    payload: payload,
});

export const getCancelOrder = (payload) => ({
    type: Types.GET_CANCEL_ORDER,
    payload: payload,
});

export const setCancelOrder = (payload) => ({
    type: Types.SET_CANCEL_ORDER,
    payload: payload,
});

export const getConfirmOrder = (payload) => ({
    type: Types.GET_CONFIRM_ORDER,
    payload: payload,
});

export const setConfirmOrder = (payload) => ({
    type: Types.SET_CONFIRM_ORDER,
    payload: payload,
});

export const emptyUnPlannedMaintenanceStatus = () => ({
    type: Types.EMPTY_STATUS,
});

export const resetOrderResponse = () => ({
    type: Types.RESET_CANCEL_ORDER,
});

export const setCreatorList = (payload) => ({
    type: Types.SET_CREATORS,
    payload: payload,
});

export const getStatusList = (payload) => ({
    type: Types.GET_STATUS,
    payload: payload,
});

export const setStatusList = (payload) => ({
    type: Types.SET_STATUS,
    payload: payload,
});

export const downloadExcelFile = (payload) => ({
    type: Types.GET_EXCEL_FILE,
    payload,
});
